// extracted by mini-css-extract-plugin
export default {"container":"ReqNotFoundScreen_container__FOXfR"};